import { publicSectionPath } from '@components/TripOverview/core'

/** The public itinerary: where its full map leads back to. */
export const publicItineraryPath = (tripCode: string): string => publicSectionPath(tripCode, 'itinerary')

/**
 * The public full map, under the itinerary so the itinerary's section share
 * setting governs it too; on one Trip day (zero-based; `?day=` is 1-based, as in
 * member mode), or the whole trip without one.
 */
export const publicTripMapPath = (tripCode: string, dayIndex?: number | null): string =>
	`${publicItineraryPath(tripCode)}/map${dayIndex === null || dayIndex === undefined ? '' : `?day=${dayIndex + 1}`}`
